const BILLABLE_SUBSCRIPTION_ORDERS_COUNT = 2;

export const getSubscriptionOrderLabel = (subscriptionOrderPosition) =>
    `${subscriptionOrderPosition}/${BILLABLE_SUBSCRIPTION_ORDERS_COUNT}`;
